import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyRefreshService {
  private readonly refresh$ = new Subject<void>();

  readonly onRefresh$ = this.refresh$.asObservable();

  requestRefresh(): void {
    this.refresh$.next();
  }
}
